import { Link } from 'react-router-dom';
import { footerLinks, siteStats } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      {/* Stats bar */}
      <div className="border-b border-foreground-800/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {siteStats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Links section */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">麻花影视</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              聚合飘花电影网、555电影、8090电影网等高清电影资源，提供最新电影、电视剧、综艺节目免费在线观看，片库全不缓冲。
            </p>
          </div>

          {/* Category links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">影视分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.link}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Platform links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">合作平台</h4>
            <ul className="space-y-2.5">
              {footerLinks.platform.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.link}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.link}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-800/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 麻花影视. All rights reserved. 本站内容来源于互联网，仅供学习交流使用。
          </p>
          <p className="text-xs text-foreground-500">
            飘花电影网 · 555电影 · 8090电影网 优质资源合作伙伴
          </p>
        </div>
      </div>
    </footer>
  );
}